import { createSelector, Selector } from '@ngxs/store';
import { Feature } from '@nimbus-global/features/feature-flipping/feature.enum';
import { IWallboardBootstrapResponse } from '../models/wallboard-data.model';
import { IWallboardStateModel, WALLBOARD_STATE_TOKEN } from './wallboard.state.model';

export class WallboardSelectors {
  public static isFeatureEnabled(feature: Feature): (state: IWallboardStateModel) => boolean {
    return createSelector([WALLBOARD_STATE_TOKEN], (state: IWallboardStateModel) => {
      const features = state?.bootstrap?.features ?? {};
      const key = Object.keys(features).find((x) => x.toLowerCase() === feature.toLowerCase());
      return key ? !!features[key] : false;
    });
  }

  @Selector([WALLBOARD_STATE_TOKEN])
  public static bootstrap(state: IWallboardStateModel): IWallboardBootstrapResponse | null {
    return state?.bootstrap ?? null;
  }

  @Selector([WALLBOARD_STATE_TOKEN])
  public static tenantId(state: IWallboardStateModel): string | null {
    return state?.bootstrap?.tenant?.id ?? null;
  }

  @Selector([WALLBOARD_STATE_TOKEN])
  public static language(state: IWallboardStateModel): string | null {
    return state?.bootstrap?.language ?? null;
  }

  @Selector([WALLBOARD_STATE_TOKEN])
  public static dateTimeFormat(state: IWallboardStateModel): string | null {
    return state?.bootstrap?.dateTimeFormat ?? null;
  }

  @Selector([WALLBOARD_STATE_TOKEN])
  public static isTimeTrackingAllowed(state: IWallboardStateModel): boolean {
    return !!state?.bootstrap?.tenant?.showUserTimeInState;
  }
}
